<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.title"
              label="标题"
              removable
              :messages="message"
              :error="!!error.titleErrors.length"
              :error-messages="error.titleErrors"
            />
          </div>
          <div class='flex md12 sm6 xs12' v-show="insertData.imageUrl.length!==0">
            <va-card
              overlay
              :image='insertData.imageUrl'
              class="va-card-image"
            >
            </va-card>
          </div>
          <div class='flex md12 sm6 xs12'>
            <va-card title='资讯背景图'>
              <va-file-upload
                type='single'
                v-model='insertData.imageUrlArr'
                @input="uploadImage"
              />
            </va-card>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.description"
              label="描述"
              type="textarea"
              removable
              :messages="message"
              :error="!!error.descriptionErrors.length"
              :error-messages="error.descriptionErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.author"
              label="作者"
              removable
              placeholder="libaedu"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-date-picker
              label="发布时间"
              :config="{enableTime: true}"
              v-model="insertData.publishTime"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <vue-trix
                v-model="insertData.content"
                placeholder="文章内容"
                :config="captionConfig"
                @trix-attachment-add="handleAttachmentChanges"
            ></vue-trix>
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.source"
              label="文章来源"
              removable
              placeholder="互联网"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-select
                label="文章状态"
                v-model="insertData.status"
                :options="statusOptions"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越小越靠前"
              removable
              type="number"
              :min="1"
            />
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import uploadApi from '../../api/upload'
import newsApi from '../../api/news'
import { copyObject, dateFormat } from '../../utils/common'

export default {
  data () {
    return {
      insertData: {
        id: null,
        title: '',
        imageUrl: '',
        imageUrlArr: [],
        description: '',
        content: '',
        author: '',
        publishTime: '',
        source: '',
        status: null,
        sortNum: null,
      },
      message: ['Required field'],
      error: {
        titleErrors: [],
        descriptionErrors: [],
      },
      showId: false,
      title: '新增资讯',
      statusOptions: ['草稿中', '已发布'],
      submitButtonStatus: true,
      captionConfig: {
        attachments: {
          preview: {
            caption: {
              name: false,
              size: false,
            },
          },
        },
      },
    }
  },
  created () {
    const params = this.$route.params
    console.log(params)
    if (params.id != null) {
      this.showId = true
      this.title = '编辑资讯'
      // 通过id获取详情
      newsApi.getNews(params.id).then(response => {
        copyObject(response, this.insertData)
        if (response.hasOwnProperty('status')) {
          if (response.status === 1) {
            this.insertData.status = '草稿中'
          } else {
            this.insertData.status = '已发布'
          }
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    }
  },
  computed: {
    formReady () {
      return !this.error.titleErrors.length &&
          !this.error.descriptionErrors.length
    },
  },
  methods: {
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      if (this.insertData.imageUrl.length === 0) {
        this.showToast('有图片未上传，请请检查后重试！', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      this.changeButtonStatus(false)
      const data = {
        title: this.insertData.title,
        imageUrl: this.insertData.imageUrl,
        description: this.insertData.description,
        author: this.insertData.author.length !== 0 ? this.insertData.author : 'libaedu',
        content: this.insertData.content,
        publishTime: this.insertData.publishTime.length !== 0 ? this.insertData.publishTime : dateFormat('YYYY-mm-dd HH:MM', new Date()),
        source: this.insertData.source.length !== 0 ? this.insertData.source : '互联网',
        sortNum: this.insertData.sortNum !== null ? this.insertData.sortNum : 1,
      }
      if (this.insertData.status === null) {
        data.status = 1;
      } else {
        if (this.insertData.status === '草稿中') {
          data.status = 1;
        } else {
          data.status = 2;
        }
      }
      if (this.insertData.id != null) {
        data.id = this.insertData.id
        newsApi.updateNews(data.id, data).then(response => {
          if (response.success === true) {
            this.$router.push({ name: 'listNews' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          console.log(error)
        })
      } else {
        newsApi.saveNews(data).then(response => {
          if (response.success === true) {
            this.$router.push({ name: 'listNews' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickCancel () {
    },
    checkField () {
      this.error.titleErrors = this.insertData.title ? [] : ['title is required']
      this.error.descriptionErrors = this.insertData.description ? [] : ['description is required']
    },
    handleAttachmentChanges (event) {
      const file = event.attachment.file
      const formData = new FormData()
      formData.append('type', 'IMAGE')
      formData.append('file', file)
      uploadApi.uploadImage(formData).then(response => {
        event.attachment.setAttributes({ url: response.url })
      }).catch(error => {
        console.log(error)
      })
    },
    uploadImage () {
      if (this.insertData.imageUrlArr.length === 0) return
      const formData = new FormData()
      formData.append('type', 'IMAGE')
      formData.append('file', this.insertData.imageUrlArr[0])
      uploadApi.uploadImage(formData).then(response => {
        this.insertData.imageUrl = response.url
      })
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
